import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<DialogLayoutFull>({})
export default class DialogLayoutFull extends Vue {
  @Prop({ default: true })
  protected closeEnabled!: boolean;

  @Prop({ default: true })
  protected footerEnabled!: boolean;

  @Prop()
  protected icon!: string;

  @Prop()
  protected title!: string;

  @Prop()
  protected bodyTitle!: string;

  @Prop()
  protected bodySubtitle!: string;

  protected mounted(): void {
    this.initialize();
  }

  protected beforeDestroy(): void {
    this.deinitialize();
  }

  protected initialize(): void {
    this.forceHideBodyScrollbar();
    this.addEscapeKeyUpEventListener();
  }

  protected deinitialize(): void {
    this.unforceHideBodyScrollbar();
    this.removeEscapeKeyUpEventListener();
  }

  protected addEscapeKeyUpEventListener(): void {
    document.addEventListener('keyup', this.escapeKeyUpEventListener);
  }

  protected close(): void {
    this.$emit('close');
  }

  protected forceHideBodyScrollbar(): void {
    this.$store.dispatch('setAppScrollbarForcedHidden', true);
  }

  protected onCloseIconClick(): void {
    if (! this.closeEnabled) { return; }

    this.$emit('close');
  }

  protected removeEscapeKeyUpEventListener(): void {
    document.removeEventListener('keyup', this.escapeKeyUpEventListener);
  }

  protected unforceHideBodyScrollbar(): void {
    this.$store.dispatch('setAppScrollbarForcedHidden', false);
  }


  protected escapeKeyUpEventListener(event: KeyboardEvent) {
    if (! this.closeEnabled || ! ['Escape'].includes(event.code)) { return; }

    this.$emit('close');
  }

  protected get isBodySubtitleAvailable(): boolean {
    return !! this.bodySubtitle;
  }

  protected get isBodyTitleAvailable(): boolean {
    return !! this.bodyTitle;
  }

  protected get isCloseIconAvailable(): boolean {
    return this.closeEnabled;
  }

  protected get isFooterAvailable(): boolean {
    return this.footerEnabled;
  }

  protected get isIconAvailable(): boolean {
    return !! this.icon;
  }

  protected get isTitleAvailable(): boolean {
    return !! this.title;
  }
}
